import {createApp} from 'vue'
import PostComments from './PostComments'

const el = '.kb-component--post-comments'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((PostCommentsDOM)=>{
            const isFrivilligContext =
                PostCommentsDOM.hasAttribute('is-frivillig-context')
            const canReply =
                PostCommentsDOM.hasAttribute('can-reply')
            const props = {
                canReply,
                isFrivilligContext,
                postId: PostCommentsDOM.dataset.postId ?? '',
                groupId: PostCommentsDOM.dataset.groupId ?? ''
            }

            const component = createApp(PostComments, props).use(Store)
            component.mount(PostCommentsDOM)
        })
    }
}